import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from './store'
import Vuelidate from 'vuelidate'
import vuetify from '@/plugins/vuetify'

Vue.config.productionTip = false

Vue.use(Vuelidate)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created ()
  {
    this.$store.dispatch('auth/checkLocalUserData')
  }
}).$mount('#app')

/**
 * Action Provider components.
 */

const ComponentContext = require.context('@/components/Action/Providers/', true, /\.vue$/i, 'lazy')

ComponentContext.keys().forEach((componentFilePath) => {

    const componentName = componentFilePath.split('/').pop().split('.').shift(),
          namespacedName = `ActionProvider${componentName}`
    
    Vue.component(namespacedName, () => ComponentContext(componentFilePath))

})

//import ActionProviderTest from '@/components/Action/Providers/Test'
//Vue.component('action-provider-test', ActionProviderTest)